import { render, staticRenderFns } from "./FpCovid19.vue?vue&type=template&id=2aa5d2d0&scoped=true&"
import script from "./FpCovid19.vue?vue&type=script&lang=js&"
export * from "./FpCovid19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5d2d0",
  null
  
)

export default component.exports